__turbopack_context__.v({
  "customUserIcon": "UserMenu-module-scss-module__nPgcXG__customUserIcon",
  "loginContainer": "UserMenu-module-scss-module__nPgcXG__loginContainer",
  "userIconWrapper": "UserMenu-module-scss-module__nPgcXG__userIconWrapper",
});
